import styled from "styled-components";

export const Background = styled.div`
  background: linear-gradient(#83b8fe, #ced9f2);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  background-image: linear-gradient(#629ff1, #ffffff);
  z-index: 1;
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const Heading = styled.h1`
  max-width: 100%;
  margin-top: 180px;
  margin-left: 45px;
  font-size: 55px;
  font-weight: bolder;
  text-align: left;
  line-height: 70px;
  color: #000000;
  margin-bottom: 120px;
`;

export const Subtitle = styled.p`
  max-width: 100%;
  margin-bottom: 15px;
  margin-left: 45px;
  margin-right: 20px;
  font-size: 20px;
  text-align: left;
  line-height: 15px;
  color: #000000;
  position: relative;
  transform: translateY(-90px);
`;

export const ResponsiveText = styled.p`
  font-weight: 400;
  line-height: 1.5;
  font-size: 25px;
  margin-right: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
  &.responsive-text {
    font-size: 20px; /* default font size */
  }
  @media only screen and (max-width: 768px) {
    &.responsive-text {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 600px) {
    &.responsive-text {
      font-size: 13px;
    }
  }
  @media only screen and (max-width: 480px) {
    &.responsive-text {
      font-size: 12px;
    }
  }
`;

export const CollabImg2 = styled.div`
  width: calc(50% - (0.5em + 6px));
  float: right;
  min-height: 400px;
  padding-top: 130px;

  @media screen and (max-width: 768px) {
    width: 80%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const Image = styled.img`
  transform: translateY(-150px);
  margin-right: 80px;
  max-height: 500px;
  float: right;
  @media screen and (max-width: 1200px) {
    position: relative;
    left: 40px;
    transform: translateY(-120px);
  }
  @media screen and (max-width: 1100px) {
    position: relative;
    left: 40px;
    transform: translateY(-80px);
  }
  @media screen and (max-width: 798px) {
    position: relative;
    left: 40px;
    transform: translateY(-70px);
  }
  @media screen and (max-width: 414px) {
    position: relative;
  }
  @media screen and (max-width: 600px) {
    position: relative;
    left: 80px;
    transform: translateY(0px);
  }
  @media screen and (max-width: 480px) {
    position: relative;
    left: -70px;
    transform: translateY(-70px);
  }
  @media screen and (max-width: 400px) {
    position: relative;
    left: 0px;
    transform: translateY(-70px);
  }
`;

export const Spacing = styled.p`
  padding: 20px;
`;
